import { Box, Icon } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'

import { forwardRef } from 'react'

import Styles from './style'

export const Datatable = forwardRef((props, ref) => {
    // const variant = props.variant || 'primary'

    function emptyOverlay() {
        return (
            <Box sx={Styles.empty}>
                <Icon
                    sx={{fontSize: '128px'}}
                >
                    {props.emptyIcon || Styles.emptyIcon || 'troubleshoot'}
                </Icon>
                <span>{props.emptyText || Styles.emptyText || 'No data available'}</span>
            </Box>
        )
    }

    const rootSx = {
        ...Styles.root,
        ...(props.sxRoot || {})
    }

    const gridSx = {
        ...Styles.grid,
        ...(props.sxGrid || {}),
        ...{'--DataGrid-overlayHeight': '300px'}
    }

    return (
        <Box sx={rootSx} ref={ref}>
            <DataGrid
                sx={gridSx}
                density={props.density || 'compact'}
                rows={props.rows || []}
                columns={props.headers || []}
                getRowId={(row) => row.id}
                pageSize={props.pageSize || 8}
                rowsPerPageOptions={props.perPage || [25, 50, 100]}
                hideFooter={(!props.displayFooter) ?? true}
                slots={{ noRowsOverlay: emptyOverlay }}
                {...props}
            />
        </Box>
    )
})

Datatable.displayName = 'Datatable'

export default Datatable